import React from 'react';
import { PlainButton, Typography } from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useGetDivElementHeight } from '../../../common/hooks/useGetDivElementHeight';
import { useGlintsVIPFreeTrialOrPurchaseModal } from '../../../modules/CreditSystem/PurchaseModals/GlintsVIPPurchaseModal/hooks/useGlintsVIPFreeTrialOrPurchaseModal';
import { StickyContainer, StyledBanner } from '../styles.sc';

const StyledButton = styled(PlainButton)`
  display: inline;
  padding: 0;
`;

type Props = {
  setFixedBannerHeight: (height: number) => void;
  closeBanner: () => void;
};

export const VIPWithSubscriptionPlan = ({
  setFixedBannerHeight,
  closeBanner,
}: Props) => {
  const { ref } = useGetDivElementHeight({
    setElementHeight: setFixedBannerHeight,
  });

  const { openGlintsVIPPurchaseModal, isModalChunkLoadPending } =
    useGlintsVIPFreeTrialOrPurchaseModal();

  return (
    <StickyContainer ref={ref}>
      <StyledBanner
        type="fixed"
        status="warning"
        showIcon={false}
        onDismiss={() => {
          closeBanner();
          setFixedBannerHeight(0);
        }}
      >
        <Typography variant="body2" color={Neutral.B18} as="div">
          <FormattedMessage
            id="text-get-vip-with-subscription-plan"
            defaultMessage="<link>Get VIP with Subscription Plan</link> and enjoy exclusive benefits!"
            values={{
              link: (text: React.ReactNode) => (
                <StyledButton
                  onClick={() => openGlintsVIPPurchaseModal()}
                  disabled={isModalChunkLoadPending}
                >
                  <Typography variant="body2">{text}</Typography>
                </StyledButton>
              ),
            }}
          />
        </Typography>
      </StyledBanner>
    </StickyContainer>
  );
};
